import { UserRoleType } from "../../../types/admin/User";
import { isType } from "../../enumChecker";

export const canRoleAddUser = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "ADMINISTRAATOR", "KVY_HALDUR", "JK_KOORDINAATOR");
};

export const canRoleAddOrganisation = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "ADMINISTRAATOR");
};

export const canRoleEditOrganisation = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleAddRegistryManagerRole = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleAddInterestedPersonRole = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleAddInterestRights = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleEditInterestRights = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleAddCoordinatorRole = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR");
};

export const canRoleAddDrafterRole = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR", "JK_KOORDINAATOR");
};

export const canRoleAddFirstGroupRoles = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "ADMINISTRAATOR");
};

export const canRoleEditRepresentationRights = (types: UserRoleType[], isManager: boolean) => {
  return (
    isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR") ||
    (isManager && isUserRoletype(types, "ADMINISTRAATOR", "JK_KOORDINAATOR"))
  );
};

export const canRoleEditGeneralData = (types: UserRoleType[], isManager: boolean) => {
  return (
    isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR") ||
    (isManager && isUserRoletype(types, "ADMINISTRAATOR", "JK_KOORDINAATOR"))
  );
};

export const canRoleEditRoles = (types: UserRoleType[], isManager: boolean) => {
  return (
    isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR") ||
    (isManager && isUserRoletype(types, "ADMINISTRAATOR", "JK_KOORDINAATOR"))
  );
};

export const showAllOrgOptions = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR");
};

export const canRoleEditAlerts = (types: UserRoleType[]) => {
  return isUserRoletype(types, "REGISTRI_HALDUR");
};

export const canRoleEditNotificationsSubscriptionButton = (types: UserRoleType[], isManager: boolean) => {
  return (
    isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR") ||
    (isManager && isUserRoletype(types, "ADMINISTRAATOR", "JK_KOORDINAATOR"))
  );
};

export const canRoleEditNotificationsSubscriptionValues = (types: UserRoleType[], isManager: boolean) => {
  return isUserRoletype(types, "REGISTRI_HALDUR") || (isManager && isUserRoletype(types, "ADMINISTRAATOR"));
};

const isUserRoletype = (types: UserRoleType[], ...matchTypes: Array<keyof typeof UserRoleType>) => {
  return types.reduce((sum, current) => sum || isType<typeof UserRoleType>(current, ...matchTypes), false);
};
